module.exports = function() {
  return new Worker(__webpack_public_path__ + "72dc5be7eb0856b96ac8.worker.js");
};